<template>
<div class="concierce_wrapper" ref="wrapper__element">
  <!-- header -->
  <div class="layer_header">
    <div class="header_inner">
      <div class="header_logo">
        <h1>
          <a @click="closeBtn">Amway</a>
        </h1>
      </div>
      <button type="button" class="btn_layer_close" @click="closeBtn">닫기</button>
    </div>
  </div>
  <!-- contents-->
  <div class="contents">
    <div class="voucher_post_box">
      <div class="voucher_post">
        <img src="./images/concierce_voucher_mo.png" alt="DIAMOND CONCIERGE PHYTO CAFE 음료바우처">
      </div>
    </div>

    <!-- S : 20250513 수정(ASB-12562) -->
    <infotagUse :expDate="endDate"/>
    <!-- E : 20250513  -->

    <!-- S: ASB-12562 추가 -->
    <counter
      text="사용"
      ref="counter__component"
      :totalCouponSum="totalCouponSum"
    />
    <!-- E: ASB-12562 -->

    <!-- S : 직원 확인 버튼 클릭 시 노출 -->
    <!-- <div class="voucher_contact" style="display: none;"> -->
    <div class="voucher_contact" v-show="exchange">
      <p>매장 선택 후, 직원 확인용 비밀번호를 입력해주세요.</p>
      <div class="contact_tel">
        <div class="contact_tel_1">
          <select class="form-tel" title="ABC 지역 입력" @change="selectBoxChange($event)">
            <option :key="i" :value="storeInfo.store_code" v-for="(storeInfo,i) in storeInfo">{{ storeInfo.store_name }} ABC</option>
          </select>
        </div>
        <div class="contact_tel_2">
          <input v-model="pinNum" type="password" class="form-tel" placeholder="****" title="비밀번호 입력" ref="pw__element">
        </div>
      </div>
    </div>
    <!-- E : 직원 확인 버튼 클릭 시 노출 -->

    <div class="concierce_btn_area">
      <!-- 바우처 교환 전 직원확인 비밀번호 입력영역 열기 버튼 활성화 case -->
      <button v-show="confirm" type="button" class="btn-pop-submit" v-on:click="confirmEMP()">직원 확인</button>
      <!-- 바우처 교환 전 case-->
      <button type="button" class="btn-pop-submit"  v-show="exchange" v-on:click="exchangeCoupon()">바우처 교환 완료 처리</button>
      <!-- 바우처 교환 완료 case -->
      <button type="button" class="btn-pop-submit" v-show="exchangeSuccess" v-bind:disabled="exchangeSuccess">교환 완료</button>
      <!-- 바우처 사용 기한 만료 case -->
      <button type="button" class="btn-pop-submit" v-show="expired" disabled  style="display:none">사용 기한 만료</button>
    </div>
  </div>
</div>
</template>

<script>
// Component
import counter from './component/counter.vue'
import infotagUse from './component/infotagUse.vue'
// Library
import axios from 'axios'

export default {
  metaInfo: {
    title: '다이아몬드 컨시어지 파이토 카페 바우처 선물하기',
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'keywords' },
      { name: 'description', content: 'NY Fee Bundle' },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:description', content: '한웨이님이 선물하신 ABC 파이토 카페 음료 바우처를 사용해 보세요.' },
      { property: 'og:image', content: './images/concierce_kakao_thumb.png' }
    ]
  },
  name: 'myCouponDTL',
  components: {
    counter, // ASB-12562 추가
    infotagUse // ASB-12562 추가
  },
  props: {
    targetUserId: Number,
    totalCouponSum: Number
  },
  data () {
    return {
      isConfirm: true,
      isExchanged: false,
      isExchangeSuccess: false,
      isExpired: false,
      ready: false,
      aboInfo: Object,
      storeInfo: [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}],
      endDate: '',
      storeCode: '',
      pinNum: '',
      inProgress: false
    }
  },
  computed: {
    confirm () {
      return this.isConfirm
    },
    exchange () {
      return this.isExchanged
    },
    exchangeSuccess () {
      return this.isExchangeSuccess
    },
    expired () {
      return this.isExpired
    }
  },
  methods: {
    init: async function () { // 초기화
      // S: ASB-12562 변경: init() 단순화
      // aboInfo
      this.aboInfo = {aboNo: '', aboName: '', aboPhone: '', pinLevel: ''}
      await this.checkLogin() // 로그인 체크(회원번호,이름)
      // storeInfo
      this.storeInfo = [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}]
      // button visibility
      this.isConfirm = true
      this.isExchanged = false
      this.isExchangeSuccess = false
      this.isExpired = false
      await this.getStoreInfo()
      // E: ASB-12562 변경
    },
    checkLogin: async function () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
        }
      }).catch(_ => {
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        window.location.href = process.env.AMWAY_ROOT_URL + '/login'
      })
    },
    closeBtn: function () {
      this.$router.go(-1)
    },
    confirmEMP: function () {
      if (this.isConfirm === true) {
        this.isConfirm = false
        this.isExchanged = true
      } else {
        this.isConfirm = true
      }
      // S: ASB-12562 변경: jQuery 제거
      setTimeout(() => {
        this.$refs.wrapper__element.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'end'})
      }, 100)
      // E: ASB-12562 변경
    },
    selectBoxChange: function (event) {
      this.storeCode = event.target.value
    },
    exchangeCoupon: async function () {
      if (this.inProgress === false) {
        this.inProgress = true
        if (this.pinNum === '') {
          alert('비밀번호를 입력하여 주십시오.')
          this.$refs.pw__element.focus()
        } else {
          await axios.post(
            process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-useCoupon',
            {
              scid: '',
              tuid: this.targetUserId, // ASB-12562: tUserId -> targetUserId
              store_cd: this.storeCode,
              pin_num: this.pinNum,
              gift: 'my',
              use_count: this.$refs.counter__component.selectedCP, // ASB-12562 수정
              created_by: 'SYSTEM',
              modified_by: 'SYSTEM'
            },
            {headers: {'Content-Type': 'application/json;charset=UTF-8'}
            }).then(response => {
            if (response.data.statusCode === 200) {
              this.confirmResult = JSON.parse(response.data.results)
              // console.log(this.confirmResult[0].resultCode)
              if (this.confirmResult[0].resultCode === 'PIN FAULT') {
                alert('비밀번호를 다시 확인해주세요.')
                this.$refs.pw__element.focus()
              } else if (this.confirmResult[0].resultCode === 'STORE INVALID') {
                alert('store invalid')
              } else if (this.confirmResult[0].resultCode === 'COUPON Not Enough' || this.confirmResult[0].resultCode === 'COUPON 0') {
                alert('쿠폰 보유수량이 부족합니다.')
                // console.log(this.confirmResult[0].resultCode)
                this.closeBtn() // ASB-12562 변경
              } else if (this.confirmResult[0].resultCode === 'SUCCESS') {
                // ABC Select box, 쿠푼교환 완료처리 버튼 숨김
                this.isExchanged = false
                // 교환완료 버튼 노출 및 disabled 처리
                this.isExchangeSuccess = true
                alert('교환 완료')
                // 메인페이지로 이동
                this.closeBtn()
              } else if (this.confirmResult[0].resultCode === 'COUPON EXPIRED') {
                alert('유효기간이 만료 되었습니다.')
                this.closeBtn()
              }
            } else {
              alert('500: Fail to use voucher')
            }
          }).catch(error => {
            console.log('error : ', error)
            alert('잠시후 다시 시도 부탁드립니다.')
          })
        }
      }
      this.inProgress = false
    },
    // store정보
    getStoreInfo: async function () {
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-myCoupon',
        {
          scid: '',
          tuid: this.targetUserId // ASB-12562: tUserId -> targetUserId
        },
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}
        }).then(response => {
        // console.log('response : ', JSON.stringify(response, null, 2))
        if (response.data.statusCode === 200) {
          this.storeInfo = JSON.parse(response.data.storeList)
          if (this.storeInfo.length > 0) {
            this.storeCode = this.storeInfo[0].store_code
          }
          this.endDate = JSON.parse(response.data.end_date)[0].end_date

          const expYear = this.endDate.substring(0, 4)
          const expMonth = this.endDate.substring(5, 7)
          const expDate = this.endDate.substring(8, 10)
          // 연도, 월, 일 추출
          const jsDate = new Date()
          const cpDate = new Date(expYear, expMonth - 1, expDate)
          const nowDate = new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate())
          // 유효기간 만료시 버튼 처리
          if (cpDate >= nowDate) {
            this.isExpired = false
          } else {
            this.isExpired = true
            this.isConfirm = false
            this.isExchanged = false
            this.isExchangeSuccess = false
          }
        } else {
          alert('Fail to load store info')
          this.closeBtn()
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('잠시후 다시 시도 부탁드립니다.')
      })
    }
  },
  mounted () {
    window.setTimeout(() => {
      this.ready = true
      this.init()
    }, 500)
    window.scrollTo(0, 0)
  }
}
</script>

<style>
    @import './css/concierce.css';
</style>



// WEBPACK FOOTER //
// src/views/concierge/myCouponDTL.vue